import { get } from 'lodash';

import { AuthStoreState, AuthError, ErrorMessageList } from '../../core/types';
import { CUSTOM_ATTRIBUTES } from '../../auth/constants';

export const getGivenNameSelector = (state: AuthStoreState): string => {
  return get(state, 'authenticatedUser.attributes.given_name', '');
};

export const getBusinessTypeSelector = (state: AuthStoreState): string => {
  return get(state, `authenticatedUser.attributes.${CUSTOM_ATTRIBUTES.BUSINESS_TYPE}`, '');
};

export const getBusinessPhoneNumberSelector = (state: AuthStoreState): string => {
  return get(state, `authenticatedUser.attributes.${CUSTOM_ATTRIBUTES.BUSINESS_PHONE_NUMBER}`, '');
};

export const getFamilyNameSelector = (state: AuthStoreState): string => {
  return get(state, 'authenticatedUser.attributes.family_name', '');
};

export const getFullNameSelector = (state: AuthStoreState): string => {
  const givenName = getGivenNameSelector(state);
  const familyName = getFamilyNameSelector(state);

  return !familyName ? givenName : `${givenName} ${familyName}`;
};

export const getIsSageIdSelector = (state: AuthStoreState): boolean => {
  return get(state, 'authenticatedUser.isSageIDUser', false);
};

export const getIsSxpManagedSelector = (state: AuthStoreState): boolean => {
  return get(state, 'authenticatedUser.isSXPManagedUser', false);
};

export const getErrorSelector = (state: AuthStoreState, typeError: string): AuthError => {
  return get(state, ['errors', typeError], null);
};

export const getErrorMessageListSelector = (state: AuthStoreState, ...typeErrors: string[]): ErrorMessageList => {
  return typeErrors.reduce((errorList: string[], typeError) => {
    const error: AuthError = get(state, ['errors', typeError], null);

    if (error) {
      errorList.push(error.message);
    }

    return errorList;
  }, []);
};
